import React from 'react';
import { Component } from '@poa/core';
import { getProfileIcon } from '../../icons/profile';
import { observable } from '@poa/state';
import { PrefetchSelect } from './general-info';
import { SingleDatePicker } from 'react-dates';
import moment from 'moment';
import CustomScatterChart from './components/Heatmap';


class AccountOperatorInfo extends React.Component {
    store; // injected by Poa
    actions; // injected by Poa
    env; // injected by Poa
    t; // injected by Poa

    localState = observable({
        selectedShiftPeriodId: null,
        selectedShiftPeriod: null,
        isCreateVisible: false,
        from: 0,
        to: 1,
        transfer_date: null,
        transferId: null,
        isDatePickerOpen: false,
        selectedDate: null,
        map_data: [],
    });

    async componentDidMount() {
        try {
            this.localState.map_data = await this.actions.accountsActions.fetchShiftMap(this.store.accounts.originalModel.id2);
        } catch (e) {
            console.log(e);
            this.env.alert('Ошибка', `Ошибка. Данные не загрузились.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`);
        }
    }

    onDateChange = event => {
        this.localState.selectedDate = moment(event._d);
    };

    setDatePickerOpen = () => {
        this.localState.isDatePickerOpen = !this.localState.isDatePickerOpen;
    };

    handleTransferEditButton = (shift) => {
        this.localState.selectedDate = moment(shift.transfer_date, 'DD.MM.YYYY HH:mm');
        this.localState.transferId = shift.id;
    }

    handleTransferUpdateButton = async () => {

        try {
            const data = await this.env.http
                .patch(`shift/transfers/${this.localState.transferId}`, {
                    transfer_date: this.localState.selectedDate.format('YYYY-MM-DD HH:mm'),
                })
                .then(response => response.data);


            this.env.alert('Успех', `Данные успешно обновлены`);

            this.store.accounts.originalModel.shiftsHistory = data;

            this.localState.selectedDate = null;
            this.localState.transferId = null;
        } catch (e) {
            console.log(e);
            this.env.alert('Ошибка', `Ошибка. Данные не обновились.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`);
        }
    }

    handleTransferCancelButton = () => {
        this.localState.selectedDate = null;
        this.localState.transferId = null;
    }

    handleCreateButton = () => {
        this.localState.isCreateVisible = true;
    }

    handleSaveButton = () => {
        this.actions.accountsActions.createShiftPeriod(
            this.localState.from,
            this.localState.to,
            this.store.accounts.originalModel.id2
        );
        this.localState.isCreateVisible = false;
    }

    handleCancelButton = () => {
        this.localState.isCreateVisible = false;
    }

    handleShiftEditButton = (shift) => {
        this.localState.selectedShiftPeriod = shift;
        this.localState.selectedShiftPeriodId = shift.id;
    }

    handleShiftCancelButton = () => {
        this.localState.selectedShiftPeriodId = null;
        this.localState.selectedShiftPeriod = null;
    }

    handleShiftDeleteButton = () => {
        this.actions.accountsActions.deleteShiftPeriod(
            this.localState.selectedShiftPeriodId,
            this.store.accounts.originalModel.id
        );

        this.localState.selectedShiftPeriodId = null;
        this.localState.selectedShiftPeriod = null;
    }

    handleShiftSaveButton = () => {

        this.actions.accountsActions.updateShiftPeriod(
            this.localState.selectedShiftPeriod.operatorID,
            this.localState.selectedShiftPeriodId,
            this.store.accounts.originalModel.id
        );

        this.localState.selectedShiftPeriodId = null;
        this.localState.selectedShiftPeriod = null;
    }

    handleShiftToChange = (e) => {
        if (parseInt(e.target.value, 10) <= this.localState.from) {
            this.env.alert('error', this.t('operatorsTab:shiftGreaterError'));
            this.localState.to = e.target.value;
        } else if (e.target.value === 0 || e.target.value === null) {
            this.env.alert('error', this.t('operatorsTab:shiftToError'));
        } else {
            this.localState.to = e.target.value;
        }
    }


    handleShiftFromChange = (e) => {
        if (parseInt(e.target.value, 10) === 24 || e.target.value === null || e.target.value === '') {
            this.env.alert('error', this.t('operatorsTab:shiftToError'));
        } else if (e.target.value >= this.localState.to) {
            this.localState.to = parseInt(e.target.value, 10) + 1;
            this.localState.from = e.target.value;
        } else {
            this.localState.from = e.target.value;
        }
    }

    render() {
        const { originalModel, isEdit } = this.store.accounts;

        const transfer_date_field = (transferId, transferDate) => {
            if (transferId !== this.localState.transferId) {
                return <h5>{transferDate}</h5>;
            } else {
                return (
                    <div className='picker-wrapper'>
                        <SingleDatePicker
                            block
                            isOutsideRange={() => false}
                            placeholder='Виберите дату'
                            focused={this.localState.isDatePickerOpen}
                            date={this.localState.selectedDate}
                            onDateChange={this.onDateChange}
                            onFocusChange={() => this.setDatePickerOpen()}
                        />
                    </div>
                );
            }
        };

        return (
            <div className='general_info__content'>
                {
                    originalModel !== null ?
                        <>
                            {isEdit && (
                                <div className='shift-row'>
                                    <button className='create_button' onClick={this.handleCreateButton}>Создать Смену</button>
                                    <div className='edit-shift-row'>
                                        {
                                            this.localState.isCreateVisible &&
                                            <>
                                                <input
                                                    id="shift-from"
                                                    type='number'
                                                    placeholder='от'
                                                    max={23}
                                                    min={0}
                                                    value={this.localState.from}
                                                    onChange={this.handleShiftFromChange}
                                                    required
                                                />
                                                <input
                                                    id="shift-to"
                                                    type='number'
                                                    placeholder='до'
                                                    max={24}
                                                    min={1}
                                                    value={this.localState.to}
                                                    onChange={this.handleShiftToChange}
                                                    required
                                                />
                                                <button className='edit_button' onClick={this.handleSaveButton}>Сохранить</button>
                                                <button className='cancel_button' onClick={this.handleCancelButton}>Отмена</button>
                                            </>
                                        }
                                    </div>
                                </div>
                            )}

                            {this.localState.map_data.length > 0 && (

                                <div className='shift-row'>
                                    <div style={{
                                        display: "flex",
                                        height: "400px",
                                        minHeight: "400px",
                                        maxHeight: "400px",
                                        overflowY: "scroll",
                                        flexDirection: "column",
                                    }}>
                                        {
                                            this.localState.map_data.map((data, idx) => (
                                                <CustomScatterChart key={idx} data={data} />
                                            ))
                                        }
                                    </div>
                                </div>
                            )}
                            <div className='shift-row'>
                                {
                                    originalModel.shifts.map((shift, idx) => (
                                        <div key={idx} className='shift-row__list'>
                                            <div className='index-number'>
                                                {idx + 1} )
                                            </div>
                                            <div className='shift-period'>{shift.from}:00 - {shift.to}:00</div>
                                            <PrefetchSelect
                                                editMode={this.localState.selectedShiftPeriodId === shift.id}
                                                optionalStyle={{ width: '200px' }}
                                                type='operators_shifts'
                                                current={shift.operatorID}
                                                accountId={originalModel.id}
                                                placeholder='никого не выбрано'
                                                onChange={value => (this.localState.selectedShiftPeriod.operatorID = value)}
                                                handleChangeExtended={val => {
                                                    if (val === null) {
                                                        return (this.localState.selectedShiftPeriod.operatorID = null);
                                                    }
                                                }}
                                            />
                                            <div className='shift-edit-buttons'>
                                                {
                                                    (this.localState.selectedShiftPeriodId !== shift.id) ?
                                                        <button
                                                            onClick={() => this.handleShiftEditButton(shift)}
                                                            className='edit-button'>
                                                            {getProfileIcon('pencil')}
                                                        </button> :
                                                        <div>
                                                            <button
                                                                onClick={() => this.handleShiftSaveButton(shift)}
                                                                className='edit-button-active'>
                                                                Cохранить
                                                            </button>
                                                            <button
                                                                onClick={this.handleShiftCancelButton}
                                                                className='edit-button-cancel'>
                                                                Отмена
                                                            </button>
                                                            <button className='edit-button-delete' onClick={() => this.handleShiftDeleteButton(shift.id)}>
                                                                удалить
                                                            </button>
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    ))}
                            </div>

                            <div className='shift-row'>
                                <div className='shift-row__list_item'
                                    style={{ borderBottom: "1px solid #E5E5E5", marginBottom: "10px", paddingBottom: "0" }}>
                                    <h4 style={{ minWidth: "40px", textAlign: "right" }}>№</h4>
                                    <h4 style={{ minWidth: "200px", textAlign: "center" }}>Смена</h4>
                                    <h4 style={{ minWidth: "200px", textAlign: "center" }}>Оператор</h4>
                                    <h4 style={{ minWidth: "200px", textAlign: "center" }}>Дата</h4>
                                </div>
                                {
                                    originalModel.shiftsHistory.map((shift, idx) => (
                                        <div key={idx} className='shift-row__list_item'>
                                            <h4>{idx + 1} )</h4>
                                            <p>{shift.from}:00 - {shift.to}:00</p>
                                            <h5>{shift.operator}</h5>
                                            {transfer_date_field(shift.id, shift.transfer_date)}
                                            {
                                                (this.localState.transferId !== shift.id) ?
                                                    <button
                                                        onClick={() => this.handleTransferEditButton(shift)}
                                                        className='edit-button'>
                                                        {getProfileIcon('pencil')}
                                                    </button> :
                                                    <div style={{ display: "ruby" }}>
                                                        <button
                                                            onClick={this.handleTransferUpdateButton}
                                                            className='edit-button-active'>
                                                            Cохранить
                                                        </button>
                                                        <button
                                                            onClick={this.handleTransferCancelButton}
                                                            className='edit-button-cancel'>
                                                            Отмена
                                                        </button>
                                                    </div>
                                            }
                                        </div>
                                    ))}
                            </div>
                        </>
                        :
                        <div className='main-row'>
                            <div className='no-profile-found-text'>
                                {getProfileIcon('noUser')}
                                Профиль не найден
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default Component({ namespaces: ['operatorsTab'] })(AccountOperatorInfo);